import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';
import RatingHelper from '@prisjakt/ui-rating/src/rating-helper';
import RatingIcon from '../../../../../../components/rating/rating-icon';
import { getSmileyRating } from '../../../../../../components/rating/utils';

import * as S from './styles';

type Props = {
  rating: number;
};

const ShopRating = ({ rating }: Props) => {
  const { t } = useContext(AppContext);

  const newRating = {
    real: RatingHelper.toReal(rating),
    string: RatingHelper.toRoundedString(rating),
  };
  const smiley = getSmileyRating(newRating.real);

  return (
    smiley && (
      <S.ShopRating>
        <RatingIcon type={smiley.iconType} disabled={false} />
        {newRating.string} • {t('reviews', smiley.text)}
      </S.ShopRating>
    )
  );
};

export default ShopRating;
